(function () {
  var HC_FILTER_MS = 180;

  function handleize(str) {
    str = String(str == null ? '' : str).toLowerCase();
    if (str.normalize) str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    str = str.replace(/[^a-z0-9\s-]/g, '');
    str = str.trim().replace(/\s+/g, '-').replace(/-+/g, '-');
    return str;
  }

  function parseMap(raw) {
    raw = String(raw || '').trim();
    if (!raw) return {};
    var out = {};
    raw.split(',').forEach(function (pair) {
      pair = String(pair || '').trim();
      if (!pair) return;
      var idx = pair.indexOf(':');
      if (idx === -1) return;
      var k = handleize(pair.slice(0, idx).trim());
      var v = handleize(pair.slice(idx + 1).trim());
      if (!k || !v) return;
      out[k] = v;
    });
    return out;
  }

  function invertMap(map) {
    var out = {};
    Object.keys(map || {}).forEach(function (k) {
      var v = map[k];
      if (v) out[v] = k;
    });
    return out;
  }

  function buildSlideCache(sliderEl, wrapperEl) {
    var slides = Array.prototype.slice.call(wrapperEl.querySelectorAll('.swiper-slide'));
    var tokenSet = {};

    slides.forEach(function (slide) {
      var cls = slide.classList;
      for (var i = 0; i < cls.length; i++) {
        var name = cls[i];
        if (name.indexOf('hc-') !== 0) continue;
        tokenSet[name.slice(3)] = true;
      }
    });

    sliderEl.__hcSlideCache = { slides: slides, tokenSet: tokenSet };
    sliderEl.__hcFilterResultCache = {};
    return sliderEl.__hcSlideCache;
  }

  function getSlideCache(sliderEl, wrapperEl) {
    var cache = sliderEl.__hcSlideCache;
    if (!cache || !cache.slides || !cache.tokenSet) {
      return buildSlideCache(sliderEl, wrapperEl);
    }
    return cache;
  }

  function wrapperHasClassToken(sliderEl, wrapperEl, token) {
    if (!token) return false;
    var cache = getSlideCache(sliderEl, wrapperEl);
    return !!cache.tokenSet[token];
  }

  function resolveTokenToSlides(sliderEl, wrapperEl, token, mapA, mapB) {
    token = handleize(token);
    if (!token) return '';
    if (wrapperHasClassToken(sliderEl, wrapperEl, token)) return token;

    var a = mapA && Object.prototype.hasOwnProperty.call(mapA, token) ? mapA[token] : '';
    var b = mapB && Object.prototype.hasOwnProperty.call(mapB, token) ? mapB[token] : '';

    if (a && wrapperHasClassToken(sliderEl, wrapperEl, a)) return a;
    if (b && wrapperHasClassToken(sliderEl, wrapperEl, b)) return b;

    var invA = invertMap(mapA || {});
    var invB = invertMap(mapB || {});

    var ai = invA && Object.prototype.hasOwnProperty.call(invA, token) ? invA[token] : '';
    var bi = invB && Object.prototype.hasOwnProperty.call(invB, token) ? invB[token] : '';

    if (ai && wrapperHasClassToken(sliderEl, wrapperEl, ai)) return ai;
    if (bi && wrapperHasClassToken(sliderEl, wrapperEl, bi)) return bi;

    return token;
  }

  function hcRestoreWrapperFromTemplate(sliderEl) {
    var wrapperEl = sliderEl.querySelector('.swiper-wrapper');
    if (!wrapperEl) return;
    var tpl = sliderEl.querySelector('template.hc-gallery-master');
    if (tpl && typeof tpl.innerHTML === 'string' && tpl.innerHTML.trim()) {
      wrapperEl.innerHTML = tpl.innerHTML;
      sliderEl.__hcSlideCache = null;
      sliderEl.__hcFilterResultCache = null;
      sliderEl.__hcVisibleSlides = null;
      sliderEl.__hcLastFilterKey = '';
      return;
    }
    if (!sliderEl.__hcFallbackMaster) sliderEl.__hcFallbackMaster = wrapperEl.innerHTML;
    wrapperEl.innerHTML = sliderEl.__hcFallbackMaster;
    sliderEl.__hcSlideCache = null;
    sliderEl.__hcFilterResultCache = null;
    sliderEl.__hcVisibleSlides = null;
    sliderEl.__hcLastFilterKey = '';
  }

  function shouldKeepSlide(slide, sizeVal, colorVal) {
    var ok = true;
    if (sizeVal) ok = ok && slide.classList.contains('hc-' + sizeVal);
    if (colorVal) ok = ok && slide.classList.contains('hc-' + colorVal);
    return ok;
  }

  function getFilterDuration() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 0;
    return HC_FILTER_MS;
  }

  function optimizeSlideImageLoading(sliderEl, keepSlides) {
    var allImgs = sliderEl.querySelectorAll('.swiper-slide img');
    for (var i = 0; i < allImgs.length; i++) {
      allImgs[i].setAttribute('loading', 'lazy');
      allImgs[i].setAttribute('decoding', 'async');
      allImgs[i].setAttribute('fetchpriority', 'low');
    }

    if (!keepSlides || !keepSlides.length) return;

    var primary = keepSlides[0].querySelector('img');
    if (primary) {
      primary.setAttribute('loading', 'eager');
      primary.setAttribute('fetchpriority', 'high');
    }

    if (keepSlides.length > 1) {
      var secondary = keepSlides[1].querySelector('img');
      if (secondary) secondary.setAttribute('fetchpriority', 'auto');
    }
  }

  function ensureFilterResultCache(sliderEl) {
    if (!sliderEl.__hcFilterResultCache) sliderEl.__hcFilterResultCache = {};
    return sliderEl.__hcFilterResultCache;
  }

  function getFilteredSlides(sliderEl, slides, sizeVal, colorVal, filterKey) {
    var byKey = ensureFilterResultCache(sliderEl);
    if (Object.prototype.hasOwnProperty.call(byKey, filterKey)) return byKey[filterKey];

    var keepSlides = [];
    for (var i = 0; i < slides.length; i++) {
      if (shouldKeepSlide(slides[i], sizeVal, colorVal)) keepSlides.push(slides[i]);
    }
    byKey[filterKey] = keepSlides;
    return keepSlides;
  }

  function arrayToMarkerMap(arr) {
    var map = Object.create(null);
    for (var i = 0; i < arr.length; i++) {
      var slide = arr[i];
      if (!slide) continue;
      var k = slide.getAttribute('data-hc-slide-key');
      if (!k) {
        k = String(i) + ':' + Math.random().toString(36).slice(2);
        slide.setAttribute('data-hc-slide-key', k);
      }
      map[k] = true;
    }
    return map;
  }

  function filterSlides(sliderEl, wrapperEl, sizeVal, colorVal, onDone) {
    var cache = getSlideCache(sliderEl, wrapperEl);
    var slides = cache.slides;
    var duration = sliderEl.__hcDidFirstFilter ? getFilterDuration() : 0;
    var filterKey = String(sizeVal || '') + '|' + String(colorVal || '');

    if (sliderEl.__hcFilterTimer) {
      clearTimeout(sliderEl.__hcFilterTimer);
      sliderEl.__hcFilterTimer = null;
    }

    if (sliderEl.__hcLastFilterKey === filterKey) {
      optimizeSlideImageLoading(sliderEl, slides.filter(function (slide) { return !slide.hidden; }));
      if (typeof onDone === 'function') onDone(false);
      return;
    }
    sliderEl.__hcLastFilterKey = filterKey;

    var keepSlides = getFilteredSlides(sliderEl, slides, sizeVal, colorVal, filterKey);
    var prevVisibleSlides = sliderEl.__hcVisibleSlides || slides.filter(function (slide) { return !slide.hidden; });
    var keepMap = arrayToMarkerMap(keepSlides);
    var prevMap = arrayToMarkerMap(prevVisibleSlides);
    var outSlides = [];
    var inSlides = [];

    for (var i = 0; i < prevVisibleSlides.length; i++) {
      var prevKey = prevVisibleSlides[i].getAttribute('data-hc-slide-key');
      if (!keepMap[prevKey]) outSlides.push(prevVisibleSlides[i]);
    }
    for (var j = 0; j < keepSlides.length; j++) {
      var inKey = keepSlides[j].getAttribute('data-hc-slide-key');
      if (!prevMap[inKey]) inSlides.push(keepSlides[j]);
    }

    slides.forEach(function (slide) {
      slide.classList.remove('hc-filter-in', 'hc-filter-out');
    });

    if (!outSlides.length) {
      optimizeSlideImageLoading(sliderEl, keepSlides);
      if (inSlides.length) {
        inSlides.forEach(function (slide) {
          slide.hidden = false;
          slide.classList.add('hc-filter-in');
        });
        requestAnimationFrame(function () {
          inSlides.forEach(function (slide) { slide.classList.remove('hc-filter-in'); });
        });
      }
      sliderEl.__hcVisibleSlides = keepSlides.slice(0);
      sliderEl.__hcDidFirstFilter = true;
      if (typeof onDone === 'function') onDone(inSlides.length > 0);
      return;
    }

    // Start fetching the next likely-visible images before transition ends.
    optimizeSlideImageLoading(sliderEl, keepSlides);
    outSlides.forEach(function (slide) { slide.classList.add('hc-filter-out'); });

    sliderEl.__hcFilterTimer = setTimeout(function () {
      outSlides.forEach(function (slide) {
        slide.hidden = true;
        slide.classList.remove('hc-filter-out');
      });

      inSlides.forEach(function (slide) {
        slide.hidden = false;
        slide.classList.add('hc-filter-in');
      });

      requestAnimationFrame(function () {
        inSlides.forEach(function (slide) { slide.classList.remove('hc-filter-in'); });
      });
      optimizeSlideImageLoading(sliderEl, keepSlides);
      sliderEl.__hcVisibleSlides = keepSlides.slice(0);
      sliderEl.__hcDidFirstFilter = true;

      if (typeof onDone === 'function') onDone(true);
    }, duration);
  }

  function findVariantWraps() {
    return Array.prototype.slice.call(document.querySelectorAll('.variant-input-wrap'));
  }

  function getSelectedFromWrap(wrap) {
    if (!wrap) return '';
    var checked = wrap.querySelector('input[type="radio"]:checked');
    if (checked) {
      var vi = checked.closest('.variant-input');
      if (vi) {
        var dv = vi.getAttribute('data-default-value');
        if (dv) return handleize(dv);
      }
      if (checked.value) return handleize(checked.value);
    }
    var sel = wrap.querySelector('select');
    if (sel && sel.value) return handleize(sel.value);
    return '';
  }

  function detectIndexByName(keys) {
    var wraps = findVariantWraps();
    for (var i = 0; i < wraps.length; i++) {
      var label = wraps[i].getAttribute('data-handle') || wraps[i].getAttribute('name') || wraps[i].getAttribute('data-index') || '';
      label = handleize(label);
      for (var j = 0; j < keys.length; j++) {
        if (label === keys[j]) return i;
      }
    }
    return -1;
  }

  function getSelectedByIndex(index) {
    var wraps = findVariantWraps();
    if (!wraps.length) return '';
    if (index < 0 || index >= wraps.length) return '';
    return getSelectedFromWrap(wraps[index]);
  }

  function initSwiper(sliderEl) {
    if (typeof Swiper === 'undefined') return null;
    return new Swiper(sliderEl, {
      direction: 'horizontal',
      loop: false,
      slidesPerView: 1,
      speed: 600,
      centeredSlides: true,
      autoHeight: true,
      pagination: { el: sliderEl.querySelector('.swiper-pagination') },
      navigation: {
        nextEl: sliderEl.querySelector('.swiper-button-next'),
        prevEl: sliderEl.querySelector('.swiper-button-prev')
      },
      effect: 'fade',
      fadeEffect: { crossFade: true }
    });
  }

  function revealSliderWhenImageReady(sliderEl) {
    if (!sliderEl) return;
    if (sliderEl.__hcRevealDone) {
      sliderEl.classList.remove('hc-loading');
      return;
    }

    function done() {
      if (sliderEl.__hcRevealDone) return;
      sliderEl.__hcRevealDone = true;
      if (sliderEl.__hcRevealTimer) {
        clearTimeout(sliderEl.__hcRevealTimer);
        sliderEl.__hcRevealTimer = null;
      }
      sliderEl.classList.remove('hc-loading');
    }

    var img = sliderEl.querySelector('.swiper-slide:not([hidden]) img') || sliderEl.querySelector('.swiper-slide img');
    if (!img) {
      done();
      return;
    }

    if (img.complete && img.naturalWidth > 0) {
      done();
      return;
    }

    if (sliderEl.__hcRevealTargetImg === img) return;
    sliderEl.__hcRevealTargetImg = img;
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
    sliderEl.__hcRevealTimer = setTimeout(done, 1200);
  }

  function bootOne(sliderEl) {
    var wrapperEl = sliderEl.querySelector('.swiper-wrapper');
    if (!wrapperEl) return;

    if (sliderEl.__hcFilterTimer) {
      clearTimeout(sliderEl.__hcFilterTimer);
      sliderEl.__hcFilterTimer = null;
    }

    if (!sliderEl.__hcBootedOnce || !wrapperEl.querySelector('.swiper-slide')) {
      hcRestoreWrapperFromTemplate(sliderEl);
      wrapperEl = sliderEl.querySelector('.swiper-wrapper');
      if (!wrapperEl) return;
      sliderEl.__hcBootedOnce = true;
    }

    var variantCount = parseInt(sliderEl.getAttribute('data-variants') || '0', 10);

    if (variantCount <= 1) {
      if (!sliderEl.__hcSwiper) sliderEl.__hcSwiper = initSwiper(sliderEl);
      if (sliderEl.__hcSwiper && sliderEl.__hcSwiper.update) {
        sliderEl.__hcSwiper.update();
        sliderEl.__hcSwiper.slideTo(0, false);
      }
      revealSliderWhenImageReady(sliderEl);
      sliderEl.__hcBootOne = function () { bootOne(sliderEl); };
      return;
    }

    var sizeIndex = sliderEl.hasAttribute('data-size-index') ? parseInt(sliderEl.getAttribute('data-size-index') || '0', 10) : -1;
    var colorIndex = sliderEl.hasAttribute('data-color-index') ? parseInt(sliderEl.getAttribute('data-color-index') || '0', 10) : -1;

    if (sizeIndex < 0) sizeIndex = detectIndexByName(['size', 'storrelse', 'storlek', 'grosse', 'groesse']);
    if (colorIndex < 0) colorIndex = detectIndexByName(['color', 'colour', 'farge', 'farg', 'farbe']);

    var sizeVal = '';
    var colorVal = '';

    if (sizeIndex >= 0) {
      var dvSize = sliderEl.getAttribute('data-value-' + sizeIndex);
      if (dvSize) sizeVal = handleize(dvSize);
    }
    if (colorIndex >= 0) {
      var dvColor = sliderEl.getAttribute('data-value-' + colorIndex);
      if (dvColor) colorVal = handleize(dvColor);
    }

    if (!sizeVal && sizeIndex >= 0) sizeVal = getSelectedByIndex(sizeIndex);
    if (!colorVal && colorIndex >= 0) colorVal = getSelectedByIndex(colorIndex);

    if (!sizeVal && sliderEl.hasAttribute('data-size-value')) sizeVal = handleize(sliderEl.getAttribute('data-size-value'));
    if (!colorVal && sliderEl.hasAttribute('data-color-value')) colorVal = handleize(sliderEl.getAttribute('data-color-value'));

    var mapEnNo = parseMap(sliderEl.getAttribute('data-hc-map-en-no'));
    var mapNoEn = parseMap(sliderEl.getAttribute('data-hc-map-no-en'));

    colorVal = resolveTokenToSlides(sliderEl, wrapperEl, colorVal, mapEnNo, mapNoEn);

    filterSlides(sliderEl, wrapperEl, sizeVal, colorVal, function (didChange) {
      if (!sliderEl.__hcSwiper) sliderEl.__hcSwiper = initSwiper(sliderEl);
      if (didChange && sliderEl.__hcSwiper && sliderEl.__hcSwiper.update) {
        sliderEl.__hcSwiper.update();
        sliderEl.__hcSwiper.slideTo(0, false);
      }

      revealSliderWhenImageReady(sliderEl);
      sliderEl.__hcBootOne = function () { bootOne(sliderEl); };
    });
  }

  function refreshAll() {
    if (refreshAll.__scheduled) return;
    refreshAll.__scheduled = true;
    requestAnimationFrame(function () {
      refreshAll.__scheduled = false;
      var sliders = document.querySelectorAll('.hc-main-slider-default');
      if (!sliders.length) return;
      Array.prototype.forEach.call(sliders, function (sliderEl) {
        if (sliderEl && typeof sliderEl.__hcBootOne === 'function') sliderEl.__hcBootOne();
        else if (sliderEl) bootOne(sliderEl);
      });
    });
  }

  window.hcCustomGalleryRefresh = refreshAll;

  function boot() {
    var sliders = document.querySelectorAll('.hc-main-slider-default');
    if (!sliders.length) return;
    Array.prototype.forEach.call(sliders, function (sliderEl) {
      bootOne(sliderEl);
    });

    ['variant:change', 'variant:select', 'variantChange'].forEach(function (evt) {
      document.addEventListener(evt, refreshAll);
    });

    document.addEventListener('change', function (e) {
      if (!e.target) return;
      if (!e.target.matches('input[name^="options"], select[name^="options"], input[data-variant-input], select[data-variant-input]')) return;
      refreshAll();
    });

    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (!m.addedNodes || !m.addedNodes.length) continue;
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (!n || n.nodeType !== 1) continue;
          if (n.matches && (n.matches('.hc-main-slider-default') || n.querySelector('.hc-main-slider-default'))) {
            refreshAll();
            return;
          }
        }
      }
    });

    obs.observe(document.documentElement, { childList: true, subtree: true });
    /* AMOK: the gallery's data-value-* attributes are updated after the variant change event fires – refilter when they change */
    var attrObs = new MutationObserver(function (muts) {
      for (var k = 0; k < muts.length; k++) {
        var t = muts[k].target;
        if (t && t.classList && t.classList.contains('hc-main-slider-default')) { refreshAll(); return; }
      }
    });
    attrObs.observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['data-value-0', 'data-value-1', 'data-value-2'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

(function () {
  function updateVariantShortDesc(variantId) {
    document.querySelectorAll('.variant-short-desc-item').forEach(function (el) {
      el.style.display = el.dataset.variantId == variantId ? '' : 'none';
    });
  }

  ['variant:change', 'variant:select', 'variantChange'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var variant = e.detail && e.detail.variant;
      if (variant) updateVariantShortDesc(variant.id);
    });
  });
})();
